import { registerComponent } from "helpers";
import StoreHours from "store-hours";

registerComponent(
  "store-status-fulfillment",
  class StoreStatusFulfillment extends StoreHours {
    constructor() {
      super();

      if (!this.config.opening_hours) {
        return;
      }

      if (this.isOpen) {
        this.classList.remove("hidden");
      } else {
        this.classList.add("hidden");
      }
    }
  },
);
